import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

type TUserCardDesktopProfileLinkProps = {
  userProfileUrl: string;
  onClick: () => void;
};

export const UserCardDesktopProfileLink: React.FC<TUserCardDesktopProfileLinkProps> = ({ userProfileUrl, onClick }) => {
  return (
    <a
      className={styles['link']}
      href={userProfileUrl}
      target="_blank"
      rel="noreferrer"
      data-testid="UserCardDesktopProfileLink"
      onClick={onClick}
    >
      <UIText1>Перейти в профиль</UIText1>
    </a>
  );
};
